import ParadoxCase from 'src/Assets/Images/Cases/paradox-case.png?width=300&height=180&ignore';
import VxLiveCase from 'src/Assets/Images/Cases/vxlive-case.png?width=300&height=180&ignore';
import VxMasterCase from 'src/Assets/Images/Cases/vxmaster-case.png?width=300&height=180&ignore';
import {ICaseModel} from 'src/Data/Cases/ICaseModel';
import EnumCasesSlugs from 'src/Routes/EnumCasesSlugs';

export const previewItems: ICaseModel[] = [
	{
		preview: ParadoxCase,
		backgroundColor: '#423ad1',
		title: 'PARADOX CRM',
		subtitleTranslationsPrefix: 'paradox',
		client: 'Tip-Top',
		slug: EnumCasesSlugs.PARADOX,
		technologies: ['react', 'laravel', 'mysql', 'redis', 'cloud'],
		statistics: [
			{label: 10, description: 'statistic.item-1'},
			{label: 4, description: 'statistic.item-2'},
			{label: 140, description: 'statistic.item-3'},
			{label: 11, description: 'statistic.item-4'},
		],
	},
	{
		preview: VxMasterCase,
		backgroundColor: '#fdb540',
		title: 'VX Master',
		subtitleTranslationsPrefix: 'vxmaster',
		client: 'campoint AG',
		slug: 'front-end-for-vx-master',
		technologies: ['react', 'graphql', 'relay'],
	},
	{
		preview: VxLiveCase,
		backgroundColor: '#ef274c',
		title: 'VxLive',
		subtitleTranslationsPrefix: 'vxlive',
		client: 'campoint AG',
		slug: 'front-end-web-streaming-tool',
		technologies: ['react', 'redux', 'lerna'],
	},
];
